module.exports = __webpack_public_path__ + "img/fant-farm-02.2677ca1e.jpg";